/* ====================================================
   FLEN Homepage — Phase 3 JS
   ==================================================== */

(function() {
  'use strict';

  /* ── Hero pills active state ── */
  document.querySelectorAll('.flen-hero-pill').forEach(function(p) {
    p.addEventListener('click', function(e) {
      /* If it has a real URL, let it navigate; if # stay and toggle */
      var href = p.getAttribute('href');
      if (!href || href === '#') {
        e.preventDefault();
      }
      document.querySelectorAll('.flen-hero-pill').forEach(function(x) {
        x.classList.remove('active');
      });
      p.classList.add('active');
    });
  });

  /* ── Quick ATC for product cards ── */
  document.querySelectorAll('.flen-atc-quick').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;

      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = 'Added!';
        setTimeout(function() {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }, 1500);

        /* Update cart count */
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            document.querySelectorAll('.flen-cart-count').forEach(function(el) {
              if (cart.item_count > 0) {
                el.textContent = cart.item_count;
                el.style.display = 'flex';
              } else {
                el.style.display = 'none';
              }
            });
          });

        /* Open cart drawer */
        var cartDrawer = document.getElementById('flenCartDrawer');
        var cartOverlay = document.getElementById('flenCartOverlay');
        if (cartDrawer && cartOverlay) {
          cartDrawer.classList.add('on');
          cartOverlay.classList.add('on');
          document.body.style.overflow = 'hidden';

          /* Render cart items */
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var container = document.getElementById('flenCartItems');
              var totalEl = document.getElementById('flenCartTotal');
              var footerEl = document.getElementById('flenCartFooter');
              if (!container) return;

              if (!cart.items || cart.items.length === 0) {
                container.innerHTML = '<div class="flen-cart-empty">Your cart is empty</div>';
                if (totalEl) totalEl.textContent = fmtMoney(0);
                if (footerEl) footerEl.style.display = 'none';
                return;
              }
              if (footerEl) footerEl.style.display = '';
              var html = '';
              cart.items.forEach(function(item) {
                var imgSrc = '';
                if (item.image) {
                  imgSrc = item.image.indexOf('?') > -1 ? item.image + '&width=140' : item.image + '?width=140';
                }
                html += '<div class="flen-ci">';
                html += '<div class="flen-ci-img">';
                if (imgSrc) html += '<img src="' + imgSrc + '" alt="" loading="lazy">';
                html += '</div>';
                html += '<div class="flen-ci-info">';
                html += '<div class="flen-ci-name">' + escH(item.product_title) + '</div>';
                if (item.variant_title) html += '<div class="flen-ci-variant">' + escH(item.variant_title) + '</div>';
                html += '<div class="flen-ci-bottom">';
                html += '<div class="flen-ci-qty">';
                html += '<button onclick="flenCartChange(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease">\u2212</button>';
                html += '<span>' + item.quantity + '</span>';
                html += '<button onclick="flenCartChange(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Increase">+</button>';
                html += '</div>';
                html += '<div class="flen-ci-price">' + fmtMoney(item.final_line_price) + '</div>';
                html += '</div>';
                html += '<a href="#" class="flen-ci-remove" onclick="flenCartChange(\'' + item.key + '\',0);return false;">Remove</a>';
                html += '</div></div>';
              });
              container.innerHTML = html;
              if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);
            });
        }
      })
      .catch(function() {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      });
    });
  });

  function fmtMoney(cents) {
    return '\u20B9' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function escH(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML;
  }

})();
